const basePath = 'https://assets.lefebvre.es/media'

export const imageURL = {
  facebook: `${basePath}/icons-2/svg/icon-rrss-facebook-square.svg`,
  instagram: `${basePath}/icons-2/svg/icon-rrss-instagram-square.svg`,
  isotype: `${basePath}/logos-2/svg/lefebvre-iso.svg`,
  linkedin: `${basePath}/icons-2/svg/icon-rrss-linkedin-square.svg`,
  logo: `${basePath}/logos-2/svg/lefebvre.svg`,
  twitter: `${basePath}/icons-2/svg/icon-rrss-x-square.svg`,
  youtube: `${basePath}/icons-2/svg/icon-rrss-youtube-square.svg`
}
